import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import {Form,Button} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  createPartner,
  getAllHomeHeader,
  getAllHomeOverview,
  getAllHomeParagraph,
  getAllHomeSlider1,
  getAllHomeSlider2,
  getAllPartners,
} from "../../api/axios";


import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Button as MainButton,
} from "@mui/material";
import { showToast } from "../../Utills/toast";
import FormGroup from "../../Components/Common/FormGroup";
import PhoneNumberInput from "../../Components/Common/PhoneInput/PhoneNumberInput";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";
import LoadingDots from '../../Components/Common/LoadingDots/LoadingDots';

// Validation Schema
const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required("First name is required."),
  last_name: Yup.string()
    .trim()
    .required("Last name is required."),
  email: Yup.string()
    .email("A valid email is required.")
    .required("Email is required."),
  phone_number: Yup.string(),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long.")
    .required("Password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords do not match.")
    .required("Confirm password is required."),
  sub_domain: Yup.string()
    .trim()
    .required("Subdomain is required."),
  membership_prefix: Yup.string()
    .trim()
    .required("Membership prefix is required."),
  group_namenum: Yup.string()
    .trim()
    .required("Group name is required."),
  logo: Yup.mixed()
    .required("Logo is required."),
  is_white_labelled: Yup.boolean()
});

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  password: "",
  confirmPassword: "",
  sub_domain: "",
  logo: null,
  is_white_labelled: false,
  membership_prefix: "",
  group_namenum: ""
};

export default function Home() {
  const { partnerId } = useParams();
  const [headerid, setHeaderId] = useState(null);
  const [slideroneid, setSliderOneId] = useState(null);
  const [slidertwoid, setSliderTwoId] = useState(null);
  const [paragraphid, setParagraphId] = useState(null);
  const [overviewid, setOverviewId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(true);

  // useEffect hook to fetch the ID from the API
  const [dropdownData, setDropdownData] = useState();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const [selectedPartnerId, setSelectedPartnerId] = useState(0);

  useEffect(() => {
    if (!Number(partnerId)) return;
    fetchHeaderData();
    fetchSilderOneData();
    fetchSilderTwoData();
    fetchParagraphData();
    fetchOverviewData();
  }, [partnerId]);

  const fetchHeaderData = async () => {
    try {
      const response = await getAllHomeHeader(partnerId);
      
      // const data = await response.json();
      if (response?.data?.data?.length > 0) {
        setHeaderId(response?.data?.data?.[0]?.header_id);
        
        
      } else {
        
      }
    } catch (error) {
      
    }
  };

  const fetchSilderOneData = async () => {
    try {
      const response = await getAllHomeSlider1(partnerId);
      if (response?.data?.data?.length > 0) {
        setSliderOneId(response?.data?.data?.[0]?.sliderOne_id);
        
      } else {
        
      }
    } catch (error) {
      
    }
  };

  const fetchSilderTwoData = async () => {
    try {
      const response = await getAllHomeSlider2(partnerId);
      if (response?.data?.data?.length > 0) {
        setSliderTwoId(response?.data?.data?.[0]?.sliderTwo_id);
        
      } else {
        
      }
    } catch (error) {
      
    }
  };

  const fetchParagraphData = async () => {
    try {
      const response = await getAllHomeParagraph(partnerId);
      if (response?.data?.data?.length > 0) {
        setParagraphId(response?.data?.data?.[0]?.paragraph_id);
        
      } else {
        
      }
    } catch (error) {
      
    }
  };

  const fetchAllPartner = async () => {
    try {
      setLoading(true);
      const response = await getAllPartners();
      const partnerData = response?.data?.data;

      let dropdownData = partnerData?.map((partner) => {
        return { title: partner?.sub_domain, value: partner?.id };
      });
      // dropdownData.unshift({ title: "Select the partner", value: 0 });
      // dropdownData.push({ title: '+ Add Partner', value: 'insert' });

        setDropdownData(dropdownData);
        // setSliderone({
        //   ...partnerData,
        //   index: response.data.data.indexOf(partnerData),
        // });
        setLoading(false);
    } catch (error) {
      setLoading(false);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || 'Something went wrong! Please try again later',
      });
      // handle error if needed
    }
  };
  useEffect(() => {
    fetchAllPartner();
  }, []);

  const handleSelectChange = (e) => {
    const { value } = e.target;
    
    if (!value || value === "0") {
      navigate(`/home`);
      return;
    }
    if (value === "insert") {
      setDialogOpen(true);
      return;
    }
    setSelectedPartnerId(value);
    navigate(`/${value}/general-settings`);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const fetchOverviewData = async () => {
    try {
      const response = await getAllHomeOverview(partnerId);
      if (response?.data?.data?.length > 0) {
        setOverviewId(response?.data?.data?.[0]?.service_id);
        
      } else {
        
      }
    } catch (error) {
      
    }
  };
  const handleFormSubmit = async (values, { setSubmitting, setFieldError, resetForm }) => {
    const formDataToSend = new FormData();

    // Append each field from values to formDataToSend
    for (const key in values) {
      if (values[key] !== null && values[key] !== undefined) {
        formDataToSend.append(key, values[key]);
      }
    }

    setSaving(true);
    setSubmitting(true);

    try {
      const res = await createPartner(formDataToSend);

      if (res.status === 200) {
        handleDialogClose();
        resetForm();
        showToast({
          type: 'success',
          message: res?.data?.message || 'Partner created successfully!',
        });
        // Refresh the dropdown data
        fetchAllPartner();
      }
    } catch (err) {
      setFieldError('general', 
        err?.response?.data?.message ||
        "Something went wrong! Please try again later"
      );
    } finally {
      setSaving(false);
      setSubmitting(false);
    }
  };

  return (
    // <Layout>
    <ContentWrapper>
      {partnerId ? (
        <>
          <Title>Select a section</Title>
          <SectionWrapper>
          <Link
              to={`/${partnerId}/home/header/view/${
                Number(headerid) ? headerid : "create"
              }`}
            >
               <Button className="mb-0 btn btn-primary">
                Header Section 
              </Button>
            </Link>
            <Link
              to={`/${partnerId}/home/slider1/view/${
                Number(slideroneid) ? slideroneid : "create"
              }`}
            >
              <Button className="mb-0 btn btn-primary">
                Slider 1 Section
              </Button>
            </Link>
            <Link
              to={`/${partnerId}/home/slider2/view/${
                Number(slidertwoid) ? slideroneid : "create"
              }`}
            >
              <Button className="mb-0 btn btn-primary">
                Slider 2 Section
              </Button>
            </Link>
            <Link
              to={`/${partnerId}/home/paragraph/view/${
                Number(paragraphid) ? paragraphid : "create"
              }`}
            >
              <Button className="mb-0 btn btn-primary">
                Paragraph Section
              </Button>
            </Link>
            <Link
              to={`/${partnerId}/home/overview/view/${
                Number(overviewid) ? overviewid : "create"
              }`}
            >
              <Button className="mb-0 btn btn-primary">
                Service Overview Section
              </Button>
            </Link>
          </SectionWrapper>
        </>
      ) : (
        <>
          <Title>Select a partner first!</Title>
          <MainBox>
            <SelectBox
              value={selectedPartnerId}
              onChange={(e) => {
                const { value } = e.target;
                if (value === "insert") {
                  setDialogOpen(true);
                  e.target.value = partnerId || 0;
                } else {
                  handleSelectChange(e);
                }
              }}
            >
              <option value={0} selected={false}>
                {loading ? (
                  <>
                    Fetching partners
                    <LoadingDots speed={200} maxDots={3} color="inherit" size="inherit" />
                  </>
                ) : (
                  "Select the partner"
                )}
              </option>
              {dropdownData?.map((option, index) => (
                <option
                  style={{ backgroundColor: "#FFF" }}
                  key={index}
                  value={option.value}
                >
                  {option?.title}
                </option>
              ))}
              <option key={"insert"} value={"insert"}>
                + Add Partner
              </option>
            </SelectBox>
          </MainBox>
        </>
      )}

    <Dialog open={dialogOpen} onClose={handleDialogClose}  fullWidth 
      maxWidth="sm">
      <DialogTitle>Add New Partner</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialFormState}
          validationSchema={validationSchema}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            getFieldProps,
          }) => (
            <form onSubmit={handleSubmit}>
              <FormGroup label="First Name" error={touched.first_name && errors.first_name} requiredField>
                <Form.Control
                  {...getFieldProps('first_name')}
                  type="text"
                  isInvalid={touched.first_name && !!errors.first_name}
                  placeholder="Enter First Name"
                />
              </FormGroup>

              <FormGroup label="Last Name" error={touched.last_name && errors.last_name} requiredField>
                <Form.Control
                  {...getFieldProps('last_name')}
                  type="text"
                  isInvalid={touched.last_name && !!errors.last_name}
                  placeholder="Enter Last Name"
                />
              </FormGroup>

              <FormGroup label="Email" error={touched.email && errors.email} requiredField>
                <Form.Control
                  {...getFieldProps('email')}
                  type="email"
                  isInvalid={touched.email && !!errors.email}
                />
              </FormGroup>

              <FormGroup label="Phone Number">
                <PhoneNumberInput
                  label='Phone Number'
                  name="phone_number"
                  value={values.phone_number}
                  error={touched.phone_number && !!errors.phone_number}
                  onChange={(value, country) => {
                    setFieldValue('phone_number', value);
                  }}
                />
              </FormGroup>

              <FormGroup label="Password" error={touched.password && errors.password} requiredField>
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    {...getFieldProps('password')}
                    type={showPassword ? "text" : "password"}
                    isInvalid={touched.password && !!errors.password}
                  />
                  <button
                    type="button"
                    style={{
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                    className="w-auto m-0 cursor-pointer position-absolute"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                  </button>
                </div>
              </FormGroup>

              <FormGroup label="Confirm Password" error={touched.confirmPassword && errors.confirmPassword} requiredField>
                <div style={{ position: 'relative' }}>
                  <Form.Control
                    {...getFieldProps('confirmPassword')}
                    type={showConfirmPassword ? "text" : "password"}
                    isInvalid={touched.confirmPassword && !!errors.confirmPassword}
                  />
                  <button
                    type="button"
                    style={{
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      fontSize: '14px',
                    }}
                    className="w-auto m-0 cursor-pointer position-absolute"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                  </button>
                </div>
              </FormGroup>

              <FormGroup label="Subdomain" error={touched.sub_domain && errors.sub_domain} requiredField>
                <Form.Control
                  {...getFieldProps('sub_domain')}
                  type="text"
                  isInvalid={touched.sub_domain && !!errors.sub_domain}
                />
              </FormGroup>

              <FormGroup label="Group Name" error={touched.group_namenum && errors.group_namenum} requiredField>
                <Form.Control
                  {...getFieldProps('group_namenum')}
                  type="text"
                  isInvalid={touched.group_namenum && !!errors.group_namenum}
                />
              </FormGroup>

              <FormGroup label="Membership Prefix" error={touched.membership_prefix && errors.membership_prefix} requiredField>
                <Form.Control
                  {...getFieldProps('membership_prefix')}
                  type="text"
                  isInvalid={touched.membership_prefix && !!errors.membership_prefix}
                />
              </FormGroup>

              <FormControlLabel
                control={
                  <Checkbox
                    name="is_white_labelled"
                    checked={values.is_white_labelled}
                    onChange={(e) => setFieldValue('is_white_labelled', e.target.checked)}
                    sx={{
                      '& .Mui-error': {
                        marginLeft: '0px',
                      }
                    }}
                  />
                }
                label="Is white label partner"
              />

              <ThemeLogo>
                {values?.logo && typeof values?.logo !== "string" ? (
                  <Box
                    component="div"
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      style={{
                        maxWidth: "13vw",
                        cursor: "pointer",
                        borderRadius: "8px",
                      }}
                      src={URL.createObjectURL(values?.logo)}
                      alt="image1"
                      onMouseEnter={(e) => {
                        e.target.style.opacity = 0.8;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = 1;
                      }}
                    />
                  </Box>
                ) : values?.logo ? (
                  <Box
                    component="div"
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      style={{
                        maxWidth: "13vw",
                        cursor: "pointer",
                        borderRadius: "8px",
                      }}
                      src={values?.logo}
                      alt="image1"
                      onMouseEnter={(e) => {
                        e.target.style.opacity = 0.8;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = 1;
                      }}
                    />
                  </Box>
                ) : (
                  ""
                )}
                <MainButton variant="contained" component="label" fullWidth>
                  Upload Logo
                  <input 
                    type="file" 
                    name="logo" 
                    onChange={(event) => {
                      setFieldValue("logo", event.currentTarget.files[0]);
                    }}
                    hidden 
                  />
                </MainButton>
              </ThemeLogo>
              {touched.logo && errors.logo && (
                <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                  {errors.logo}
                </p>
              )}

              {errors.general && (
                <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                  {errors.general}
                </p>
              )}

              <DialogActions>
                <MainButton onClick={handleDialogClose} color="error">
                  Cancel
                </MainButton>
                <MainButton type="submit" color="primary" disabled={isSubmitting || saving}>
                  {isSubmitting || saving ? 'Submitting...' : 'Submit'}
                </MainButton>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
      {/* </Layout> */}
    </ContentWrapper>
  );
}

const MainBox = styled.div`
  max-width: 340px;
  margin: auto;
`;


const ContentWrapper = styled.div`
    @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
text-align: center;
     @media (min-width:576px) {
   margin-bottom: .5rem;
  }
   @media (min-width:768px) {
    margin-bottom: 1rem;
  }
   margin-bottom: .25rem;
`;

const SectionWrapper = styled.div`
  /* justify-content: center;
  align-items: center;
  gap: 12px; */
  display: flex;
  gap: 6rem;
  justify-content: center;
   @media (max-width:1400px) {
    gap: 2rem !important;
   }
     @media (max-width:1200px) {
    gap: 1rem !important;
   }
      @media (max-width:694px) {
   flex-wrap: wrap;
   }
     @media (max-width:369px) {
   flex-direction:column;
   gap: 0.5rem !important;
   }
`;

const SelectBox = styled.select`
  width: 100%;
  height: 45px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  background: white;
  outline: none;
`;

const ThemeLogo = styled.div`
  border: 1px solid #d1d5db;
  width: 100%;
  padding: 10px;
  margin: 10px 12px;
  border-radius: 10px;
  background-color: #f2f2f2;
  max-width: fit-content;
  img {
    margin-bottom: 23px;
  }
`;